const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN || "";

export const isAuth0ConnectivityCheckConfigured = (): boolean =>
  Boolean(AUTH0_DOMAIN);

export const checkAuth0DomainConnectivity = async (): Promise<{
  domain: string;
  reachable: boolean;
}> => {
  try {
    const response = await Promise.race([
      fetch(`https://${AUTH0_DOMAIN}/.well-known/openid-configuration`),
      new Promise<never>((_, reject) =>
        setTimeout(() => reject(new Error("Timeout")), 5000),
      ),
    ]);
    return { domain: AUTH0_DOMAIN, reachable: response.ok };
  } catch {
    return { domain: AUTH0_DOMAIN, reachable: false };
  }
};
